import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-box" }
const _hoisted_2 = { class: "input-box" }
const _hoisted_3 = { class: "textarea-box" }
const _hoisted_4 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_5 = { class: "modal" }
const _hoisted_6 = { class: "modal-header" }

import Vue, {ref} from 'vue';
import axios from "axios";
import Toast from '@/components/Toast.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'form',
  setup(__props) {

let email = ref('')
let comments = ref('')
let refShowModal = ref(false)

const isEmail = (s) => {
  return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,4}){1,2})$/.test(s)
}
const OnSubscribe = () => {
  const valEmail = email.value;

  if (valEmail.length == 0) {
    showFailed('Please enter your email address')
    return
  }

  if (valEmail.length > 64) {
    showFailed('Please enter your email address')
    return
  }

  if (!isEmail(valEmail)) {
    showFailed('Please enter correct email address')
    return
  }
  if (comments.value.length == 0) {
    showFailed('Please enter your suggestions or comments')
    return
  }
  let jsStr = localStorage.getItem('ccenv') || '{}'
  let ccenv = JSON.parse(jsStr)
  if (ccenv.ss !== undefined && new Date().getTime() - ccenv.ss < 1000 * 10) {
    showSucc()
    return
  }

  axios.post("/api/message/add", {
    "email": valEmail,
    // "name": valNames,
    "comments": comments.value,
  }).then(rsp => {
    console.log(rsp);

    if (rsp.status == 200 && rsp.data['code'] == 0) {
      console.log('subscribe...OK')
      localStorage.setItem('ccenv', JSON.stringify(JSON.parse('{"ss":' + new Date().getTime() + '}')))
      comments.value = ''
      email.value = ''
      showSucc()
      return
    }
    showFailed('error')
  })
}

const showSucc = () => {
  refShowModal.value = true
}
const msgText = ref('')
const showToast = ref(false)
const showFailed = (msg:string) => {
  msgText.value = msg
  showToast.value = true
  setTimeout(() => {
    showToast.value = false
  }, 2000)
  refShowModal.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "big-title" }, [
      _createElementVNode("span", null, "CONTACT")
    ], -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "introduce-text" }, " Welcome to leave us your suggestions and comments. We will keep your contact information strictly confidential, We will send you the latest news about the game by email: ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Please enter your email address",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event))
      }, null, 512), [
        [_vModelText, _unref(email)]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "Please enter your suggestions or comments",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(comments) ? (comments).value = $event : comments = $event))
      }, null, 512), [
        [_vModelText, _unref(comments)]
      ])
    ]),
    _createElementVNode("div", {
      class: "submit",
      onClick: OnSubscribe
    }, "Submit"),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(refShowModal))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("header", _hoisted_6, [
                _createElementVNode("button", {
                  class: "close",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(refShowModal) //@ts-ignore
 ? refShowModal.value = false : refShowModal = false))
                }),
                _createElementVNode("button", {
                  class: "confirm",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(refShowModal) //@ts-ignore
 ? refShowModal.value = false : refShowModal = false))
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (showToast.value)
      ? (_openBlock(), _createBlock(Toast, {
          key: 0,
          "msg-text": msgText.value
        }, null, 8, ["msg-text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})